// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import equal from 'NewAngular/utils/equal/deep-equal';
// Actions
import { removeFundChartSecurity, setFundChartSecurities, toggleFundChartSecurity, updateFundChartSecurityOrdering, addFundChartSecurities, } from './securities.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const securities = createReducer([], on(setChartData, (state, { chartData }) => chartData.params.securities), on(addFundChartSecurities, (state, action) => {
    const securitiesToAdd = action.fundChartSecurities.filter((security) => {
        return !state.find((_) => equal(_, security));
    });
    return [...state, ...securitiesToAdd];
}), on(removeFundChartSecurity, (state, action) => {
    return state.filter((security) => security.id !== action.fundChartSecurity.id);
}), on(setFundChartSecurities, (state, action) => {
    return action.fundChartSecurities;
}), on(setFundChart, (state, action) => {
    return action.fundChart.securities;
}), on(toggleFundChartSecurity, (state, action) => {
    return state.map((security) => {
        if (security.id === action.fundChartSecurity.id) {
            const include = !action.fundChartSecurity.include;
            return { ...security, include };
        }
        return security;
    });
}), on(updateFundChartSecurityOrdering, (state, action) => {
    const updatedOrdering = [...state];
    const { oldIndex, newIndex } = action;
    updatedOrdering.splice(newIndex, 0, updatedOrdering.splice(oldIndex, 1)[0]);
    return updatedOrdering;
}));
